module.exports = __webpack_public_path__ + "static/media/dropdown-up-icon.a6d07ea3.png";